import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { CountrySummary, ProductSummary } from '@/api/types';

export function useProductSearch(query: string) {
  return useQuery({
    queryKey: ['products', query],
    queryFn: async () =>
      (await api.get<Array<ProductSummary>>('/products', { params: { q: query } })).data,
    enabled: query.length > 0,
  });
}

export function useCountries() {
  return useQuery({
    queryKey: ['countries'],
    queryFn: async () => (await api.get<Array<CountrySummary>>('/countries')).data,
  });
}
